import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=413a6797"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports